import logo from './logo.svg';
import MultiLineChart from "./views/MultiLineChart.js";
import Controls from "./views/Controls.js";
import './App.css';

import React from 'react';
import * as d3 from "d3";

const dimensions = {width: 1200, height: 600, margin: { inline: 100, block: 30 }};

function App() {
  const ranks = require('./ranks.json');

  const [ players, setPlayers ] = React.useState(new Map());
  const [ newPlayer, setNewPlayer ] = React.useState("");

  const clickAddPlayer = event => {
    event.preventDefault();

    // setPlayers(players.concat([newPlayer]));
    if (!players.has(newPlayer.toLowerCase())) {
      const _players = new Map(players);
      const randomHex = () => Math.floor(64 + Math.random() * 192);
      const randomColor = `rgb(${randomHex()}, ${randomHex()}, ${randomHex()})`;
      _players.set(newPlayer.toLowerCase(), randomColor);
      console.log(_players);
      setPlayers(_players);
    }
    setNewPlayer("");
  };

  const clickDeletePlayer = (player, event) => {
    event.preventDefault();
    const _players = new Map(players);
    _players.delete(player);
    setPlayers(_players);
  };

  return (
    <div className="App">
      <MultiLineChart players={players} data={ranks} dimensions={dimensions} />
      <Controls players={players} newPlayer={newPlayer} setNewPlayer={setNewPlayer} clickAddPlayer={clickAddPlayer} clickDeletePlayer={clickDeletePlayer} />
    </div>
  );
}

export default App;
